"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_USER = void 0;
const client_1 = require("@apollo/client");
exports.GET_USER = (0, client_1.gql) `
  query currentUser {
    currentUser {
      id
      name
      email
      admin
      weeklyPerformanceEmail
    }
  }
`;
